import { useState } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function VideoGallery() {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Videos' },
    { id: 'school', name: 'School Life' },
    { id: 'academics', name: 'Academics' },
    { id: 'sports', name: 'Sports' },
    { id: 'events', name: 'Events' },
    { id: 'graduation', name: 'Graduation' }
  ];

  const videoGallery = [
    {
      id: 1,
      src: "https://www.youtube.com/embed/hbLX16Y_G8k?si=vkBzSkPSEMAxNXHn",
      thumbnail: "https://placehold.co/400x225/1e40af/white?text=School+Tour",
      alt: "School Tour",
      category: "School",
      title: "Virtual School Tour",
      duration: "1:00"
    },
    {
      id: 2,
      src: "https://www.youtube.com/embed/jNQXAC9IVRw",
      thumbnail: "https://placehold.co/400x225/059669/white?text=Interactive+Learning",
      alt: "Interactive Learning",
      category: "academics",
      title: "Interactive Classroom Session",
      duration: "2:30"
    },
    {
      id: 3,
      src: "https://www.youtube.com/embed/-sYy6PGePHA?si=rW0PYQCaRwWD66Nl",
      thumbnail: "https://placehold.co/400x225/dc2626/white?text=School+Advertisement",
      alt: "School Advertisement",
      category: "Advertisement",
      title: "School Advertisement",
      duration: "1:00"
    },
    {
      id: 4,
      src: "https://www.youtube.com/embed/scyeIERAwqo?si=iz59hLhfYs49CZAw",
      thumbnail: "https://placehold.co/400x225/7c3aed/white?text=Science+Lab",
      alt: "Science Lab",
      category: "academics",
      title: "Science Laboratory Experiments",
      duration: "0:59"
    },
    {
      id: 5,
      src: "https://www.youtube.com/embed/abw4CBjgtF0?si=bn9FYLgrq3lSrg8s",
      thumbnail: "https://placehold.co/400x225/f59e0b/white?text=Graduation+Ceremony",
      alt: "Graduation Ceremony",
      category: "graduation",
      title: "Graduation Day Highlights",
      duration: "0:30"
    },
    {
      id: 6,
      src: "https://www.youtube.com/embed/yWcvK4tW5NM?si=Xckad54aeSF39LIi",
      thumbnail: "https://placehold.co/400x225/0891b2/white?text=School+Introduction",
      alt: "",
      category: "Introduction",
      title: "My Rehoboth Schools, A Beacon of Knowledge",
      duration: "0:31"
    },
    {
      id: 7,
      src: "https://www.youtube.com/embed/lAZpjxeg-LU?si=CUOWQUSkD5kya4x-",
      thumbnail: "https://placehold.co/400x225/16a34a/white?text=Sports+Event",
      alt: "Sports",
      category: "sports",
      title: "Inter House Sport",
      duration: "2:15"
    },
    {
      id: 8,
      src: "https://www.youtube.com/embed/VJT1h56w50o?si=xlb48pJaVBFN1Ehy",
      thumbnail: "https://placehold.co/400x225/be185d/white?text=ICT+Lab",
      alt: "ICT Lab",
      category: "academics",
      title: "ICT Lab Tour",
      duration: "0:46"
    },
    {
      id: 9,
      src: "https://www.youtube.com/embed/JGwWNGJdvx8",
      thumbnail: "https://placehold.co/400x225/ea580c/white?text=Annual+Day",
      alt: "Annual Day",
      category: "events",
      title: "Annual Day Celebration",
      duration: "6:20"
    },
    {
      id: 10,
      src: "https://www.youtube.com/embed/KXV25Ehzqvg?si=RlsCpgbKLQiRpNic",
      thumbnail: "https://placehold.co/400x225/7c2d12/white?text=Physics+Lab",
      alt: "Physics Lab",
      category: "School",
      title: "A Day in Physics Lab",
      duration: "0:30"
    },
    {
      id: 11,
      src: "https://www.youtube.com/embed/hqYbdc_YTTw?feature=shared",
      thumbnail: "https://placehold.co/400x225/0d9488/white?text=Innovative",
      alt: "Innovative Mind",
      category: "Innovative",
      title: "Building Innovative Mind",
      duration: "0:27"
    },
    {
      id: 11,
      src: "https://www.youtube.com/embed/Ea16bfNXHak?si=deQAFJns4nrWTj-V",
      thumbnail: "https://placehold.co/400x225/0d9488/white?text=News+Club",
      alt: "News",
      category: "News",
      title: "The School Press Club Casting News",
      duration: "1:12"
    },
    {
      id: 12,
      src: "https://www.youtube.com/embed/i_OeFfJTw0A?si=IQ_0nPWRBFcU_ReH",
      thumbnail: "https://placehold.co/400x225/7e22ce/white?text=School+Prefects",
      alt: "School Prefects",
      category: "graduation",
      title: "Academic Achievement",
      duration: "0:30"
    }
  ];

  const filteredVideos = selectedCategory === 'all' 
    ? videoGallery 
    : videoGallery.filter(video => video.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      
      <div className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-6xl font-bold text-green-900 mb-6">Video Gallery</h1>
              <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                Experience the vibrant life and dynamic moments at My Rehoboth Schools through our video collection.
              </p>
            </div>
          </div>
        </section>

        {/* Gallery Overview */}
        <section className="py-16 md:py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-6 md:mb-8">Visual Stories of Excellence</h2>
                <div className="space-y-4 md:space-y-6 text-gray-600 leading-relaxed">
                  <p className="text-base md:text-lg">
                    Our video gallery brings to life the dynamic experiences that define My Rehoboth Schools. 
                    From immersive School tours to academic demonstrations, sporting events to cultural celebrations, 
                    these videos showcase the energy and spirit of our educational community.
                  </p>
                  <p className="text-base md:text-lg">
                    Each video captures the essence of holistic education in action, where students engage in 
                    meaningful learning experiences, build lasting friendships, and develop their talents in a 
                    supportive environment that fosters growth and achievement.
                  </p>
                  <p className="text-base md:text-lg">
                    Explore our collection to witness the excitement of discovery, the thrill of competition, 
                    the joy of creativity, and the pride of accomplishment that makes My Rehoboth Schools truly special.
                  </p>
                </div>
              </div>
              <div>
                <div className="relative w-full h-64 md:h-96 bg-gradient-to-br from-blue-400 to-green-400 rounded-2xl shadow-lg flex items-center justify-center">
                  <div className="text-center text-white p-6">
                    <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold mb-2">Video Showcase</h3>
                    <p className="text-green-100">Click any video to play</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3 md:gap-4">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                    selectedCategory === category.id
                      ? 'bg-green-600 text-white shadow-lg'
                      : 'bg-white text-gray-600 hover:bg-green-50 hover:text-green-600'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Video Grid */}
        <section className="py-16 md:py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
              {filteredVideos.map((video) => (
                <div
                  key={video.id}
                  className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                  onClick={() => setSelectedVideo(video)}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={video.thumbnail}
                      alt={video.alt}
                      className="w-full h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                      <div className="w-12 h-12 bg-white bg-opacity-90 rounded-full flex items-center justify-center group-hover:bg-opacity-100 transition-all duration-300">
                        <svg className="w-6 h-6 text-red-600 ml-1" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
                      {video.duration}
                    </div>
                  </div>
                  <div className="p-4 md:p-6">
                    <h3 className="text-lg md:text-xl font-bold text-green-900 mb-2">{video.title}</h3>
                    <p className="text-sm md:text-base text-gray-600 capitalize">{video.category.replace('-', ' ')}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery Statistics */}
        <section className="py-16 md:py-20 bg-green-900 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-6">Our Video Collection</h2>
              <p className="text-lg md:text-xl text-green-200 max-w-3xl mx-auto">
                Bringing our school story to life through video
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {[
                {
                  number: "50+",
                  label: "Videos Available",
                  icon: "ri-video-line"
                },
                {
                  number: "25+",
                  label: "Events Covered",
                  icon: "ri-calendar-event-line"
                },
                {
                  number: "12",
                  label: "Years Documented",
                  icon: "ri-time-line"
                },
                {
                  number: "1000+",
                  label: "Total Views",
                  icon: "ri-eye-line"
                }
              ].map((stat, index) => (
                <div key={index} className="text-center bg-green-800 rounded-2xl p-6 md:p-8">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                    <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                      {stat.icon === "ri-video-line" && <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"/>}
                      {stat.icon === "ri-calendar-event-line" && <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>}
                      {stat.icon === "ri-time-line" && <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"/>}
                      {stat.icon === "ri-eye-line" && <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>}
                    </svg>
                  </div>
                  <div className="text-2xl md:text-3xl font-bold mb-2">{stat.number}</div>
                  <div className="text-sm md:text-base text-green-200">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedVideo(null)}
        >
          <div className="relative w-full max-w-4xl max-h-full bg-white rounded-lg overflow-hidden">
            <div className="aspect-video w-full">
              <iframe
                src={selectedVideo.src}
                title={selectedVideo.title}
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                onClick={(e) => e.stopPropagation()}
              ></iframe>
            </div>
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-4 right-4 bg-black bg-opacity-50 text-white text-2xl w-10 h-10 rounded-full flex items-center justify-center hover:bg-opacity-70 transition-all duration-300"
            >
              ×
            </button>
            <div className="p-4 bg-white">
              <h3 className="text-xl font-bold text-gray-900">{selectedVideo.title}</h3>
              <p className="text-gray-600 capitalize">{selectedVideo.category.replace('-', ' ')}</p>
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}